import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Phone = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="phone icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1221 17.8825L19.6864 15.2918C19.0996 14.7062 18.1832 14.6713 17.6392 15.2159L15.2403 17.6141C15.0367 17.8189 14.914 18.0749 14.8713 18.3455C13.21 17.2383 11.4868 15.833 9.82717 14.1734L9.80016 14.1981L9.82604 14.1728C8.16643 12.5127 6.7611 10.7912 5.65451 9.12874C5.92511 9.08542 6.18221 8.96334 6.3853 8.75912L8.78414 6.36084C9.32872 5.81683 9.29384 4.90038 8.70876 4.31361L6.11695 0.877933C5.53074 0.291724 4.92034 -0.319801 3.45932 0.191022C2.13388 0.653463 1.39053e-05 2.67706 1.39053e-05 5.48265C-0.00673706 8.43676 2.44499 12.8153 6.69697 17.0988L6.69585 17.0999C6.71272 17.1174 6.73016 17.1331 6.74704 17.1506C6.76448 17.168 6.78023 17.1854 6.79711 17.2023L6.7988 17.2006C11.084 21.4549 15.5632 24.0073 18.5168 24C21.3235 24 23.346 21.8656 23.809 20.5407C24.3198 19.0797 23.7083 18.4693 23.1221 17.8825"
    />
  </svg>
)
